// GanttChartApp.js 완전 수정 버전

import { useState, useRef, useEffect, useCallback } from "react"; // useCallback 추가
import styled from "styled-components";
import GanttChart from "./components/GanttChart";
import GanttChartWBS from "./components/GanttChart/GanttChartWBS";
import ReportView from "./components/GanttChart/ReportView";
import Sidebar from "./components/GanttChart/sidebar";
import Header from "./components/GanttChart/header";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { useSocket } from "./context/SocketContext";
import { toast } from "react-hot-toast";
import { confirmDialog } from "./utils/confirmDialog";
import { promptDialog } from "./utils/promptDialog";
import { buildTutorialTasks } from "./utils/tutorialTasks";

// 새로운 컴포넌트 추가
import SaveChartModal from "./components/GanttChart/SaveChartModal";
import LoadChartModal from "./components/GanttChart/LoadChartModal";
import MembersModal from "./components/GanttChart/MembersModal";
import ColorSettingsModal from "./components/GanttChart/ColorSettingsModal";
import ShareModal from "./components/GanttChart/ShareModal";
import WelcomeDashboard from "./components/GanttChart/WelcomeDashboard";
import BacklogModal from "./components/GanttChart/BacklogModal";
import AlarmSettingsModal from "./components/GanttChart/AlarmSettingsModal";
import TaskNotePanel from "./components/GanttChart/TaskNotePanel";
import ChartTypeSelectModal from "./components/GanttChart/ChartTypeSelectModal";
import StatsStrip from "./components/GanttChart/StatsStrip";
import GlobalDrawer from "./components/GanttChart/GlobalDrawer";
import TaskDetailsPanel from "./components/GanttChart/TaskDetailsPanel";
import GlobalCursorLayer from "./components/GanttChart/GlobalCursorLayer";
import useCollaborativeChart from "./hooks/useCollaborativeChart";

const AppLayout = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`

const DrawerSlot = styled.div`
  width: ${(p) => (p.$open ? "280px" : "0px")};
  flex-shrink: 0;
  overflow: hidden;
  transition: width 0.22s ease;
  background: #0f172a;

  @media (max-width: 900px) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 200;
    width: 280px;
    max-width: 86vw;
    transform: translateX(${(p) => (p.$open ? "0" : "-100%")});
    transition: transform 0.22s ease;
    box-shadow: 6px 0 28px rgba(2, 6, 23, 0.45);
  }
`

const DrawerBackdrop = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: ${(p) => (p.$open ? "block" : "none")};
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    z-index: 199;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  background-color: white;
`;


const ResizableContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
`

const SidebarContainer = styled.div`
  width: ${props => props.width}px;
  min-width: 250px;
  max-width: 600px;
  flex-shrink: 0;
  background-color: white;
  border-right: 1px solid #e5e7eb;
  overflow: hidden;

  /* 모바일: 드로어 형태 (오버레이) */
  @media (max-width: 900px) {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 85vw;
    max-width: 360px;
    z-index: 50;
    box-shadow: ${props => props.$open ? '4px 0 24px rgba(0,0,0,0.2)' : 'none'};
    transform: ${props => props.$open ? 'translateX(0)' : 'translateX(-100%)'};
    transition: transform 0.22s ease-out;
  }
`

const MobileBackdrop = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: ${props => props.$show ? 'block' : 'none'};
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.35);
    z-index: 40;
  }
`

const ResizeHandle = styled.div`
  width: 4px;
  background-color: #e5e7eb;
  cursor: col-resize;
  position: relative;
  flex-shrink: 0;

  &:hover { background-color: #d1d5db; }
  &:active { background-color: #9ca3af; }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 20px;
    background-color: #9ca3af;
    border-radius: 1px;
  }

  @media (max-width: 900px) { display: none; }
`

const ChartContainer = styled.div`
  flex: 1;
  overflow: hidden;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

const ChartBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

const DetailsSlot = styled.div`
  width: ${(p) => (p.$open ? "380px" : "0px")};
  flex-shrink: 0;
  overflow: hidden;
  transition: width 0.22s ease;
  background: white;
  border-left: ${(p) => (p.$open ? "1px solid #e5e7eb" : "none")};

  @media (max-width: 1100px) {
    width: ${(p) => (p.$open ? "340px" : "0px")};
  }

  @media (max-width: 900px) {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 180;
    width: 340px;
    max-width: 90vw;
    transform: translateX(${(p) => (p.$open ? "0" : "100%")});
    transition: transform 0.22s ease;
    box-shadow: -6px 0 28px rgba(15, 23, 42, 0.18);
    border-left: 1px solid #e5e7eb;
  }
`
export default function GanttChartApp() {
  const navigate = useNavigate();
  const { shareToken } = useParams();
  const { isLoggedIn, user } = useAuth();
  const { joinChart, leaveChart } = useSocket();
  
  // 모달 상태
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [isLoadModalOpen, setIsLoadModalOpen] = useState(false);
  const [isMembersModalOpen, setIsMembersModalOpen] = useState(false);
  const [isColorModalOpen, setIsColorModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  
  // 파일 관리 상태
  const [chartTitle, setChartTitle] = useState("");
  const [savedCharts, setSavedCharts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentFileName, setCurrentFileName] = useState(null); // 현재 파일명
  const [currentFileId, setCurrentFileId] = useState(null);     // 현재 파일 ID
  const [welcomeDismissed, setWelcomeDismissed] = useState(false); // 빈 상태에서 환영 화면 닫음 여부
  const [isBacklogOpen, setIsBacklogOpen] = useState(false);
  const [isAlarmModalOpen, setIsAlarmModalOpen] = useState(false);
  const [noteTask, setNoteTask] = useState(null); // 노트 패널에 띄울 task (null이면 닫힘)
  const [currentChartType, setCurrentChartType] = useState("personal"); // 'personal' | 'team'
  const [isChartTypeModalOpen, setIsChartTypeModalOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [addTaskNonce, setAddTaskNonce] = useState(0);
  const [addMilestoneNonce, setAddMilestoneNonce] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  
  // 데이터 상태
  const [activeTab, setActiveTab] = useState("tasks");
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [viewMode, setViewMode] = useState("day");
  const [chartTheme, setChartTheme] = useState("classic"); // "classic" 또는 "wbs"
  const [referenceDate, setReferenceDate] = useState(new Date()); // 목표 진척률 계산 기준일

  //// 리사이즈 관련 상태 추가
  const [sidebarWidth, setSidebarWidth] = useState(320);
  const [isResizing, setIsResizing] = useState(false);
  const resizeRef = useRef(null);

  // 작업 타입별 색상 상태
  const [taskTypes, setTaskTypes] = useState([
    { id: 'development', name: '개발', color: '#4EA8DE' },
    { id: 'design', name: '디자인', color: '#8884D8' },
    { id: 'planning', name: '기획', color: '#82CA9D' },
    { id: 'testing', name: '테스트', color: '#FFBB28' },
    { id: 'deployment', name: '배포', color: '#FF8042' }
  ]);

  // 데이터 상태
  const [users, setUsers] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [tasks, setTasks] = useState([]);

  // 실시간 협업 훅
  const collab = useCollaborativeChart({
    currentFileId,
    tasks,
    setTasks,
    milestones,
    setMilestones,
    users,
    setUsers,
  });

// 리사이즈 핸들러들 (기존 함수들 위에 추가)
// handleMouseDown 수정 (가장 중요!)
// handleMouseDown 수정
const handleMouseDown = (e) => {
  e.preventDefault();
  setIsResizing(true);
  resizeRef.current = {
    startX: e.clientX,
    startWidth: sidebarWidth,
  };
  
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
  
  document.body.style.userSelect = 'none';
  document.body.style.cursor = 'col-resize';
};

// handleMouseMove는 기존 그대로 유지
// handleMouseMove를 useCallback으로 감싸기
const handleMouseMove = useCallback((e) => {
  if (!resizeRef.current) return; // isResizing 체크 제거
  
  const deltaX = e.clientX - resizeRef.current.startX;
  const newWidth = resizeRef.current.startWidth + deltaX;
  console.log('새로운 너비:', newWidth);
  
  if (newWidth >= 250 && newWidth <= 600) {
    setSidebarWidth(newWidth);
  }
}, []); // 의존성 배열 비우기

// handleMouseUp도 useCallback으로 감싸기
const handleMouseUp = useCallback(() => {
  setIsResizing(false);
  resizeRef.current = null;
  
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
  
  document.body.style.userSelect = '';
  document.body.style.cursor = '';
}, [handleMouseMove]); // handleMouseMove 의존성 추가
// cleanup effect 추가
useEffect(() => {
  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
  };
}, []);
  // 작업 타입 색상 저장 함수
  const handleSaveTaskColors = (updatedTypes) => {
    setTaskTypes(updatedTypes);
    toast.success('작업 색상 설정이 저장되었습니다.');
    localStorage.setItem('taskTypes', JSON.stringify(updatedTypes));
  };

  // 초기 로드시 로컬 스토리지에서 불러오기
  useEffect(() => {
    const savedTaskTypes = localStorage.getItem('taskTypes');
    if (savedTaskTypes) {
      try {
        setTaskTypes(JSON.parse(savedTaskTypes));
      } catch (e) {
        console.error('작업 타입 불러오기 실패:', e);
      }
    }
  }, []);

  // 작업 추가/수정 시 색상 자동 지정
  const getTaskColor = (taskType) => {
    const typeConfig = taskTypes.find(type => type.id === taskType);
    return typeConfig ? typeConfig.color : '#4EA8DE';
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/Login');
    }
  }, [isLoggedIn, navigate]);

  // 공유 링크로 접속 시 자동 차트 로드
  useEffect(() => {
    if (!shareToken || !isLoggedIn) return;

    const loadSharedChart = async () => {
      try {
        const res = await fetch(`/request/shared/${shareToken}`, {
          credentials: 'include',
        });
        const data = await res.json();
        if (data.success && data.chartId) {
          handleLoadChart(data.chartId);
          return;
        }
        // 공유 토큰이 아니면 차트 ID 직접 접근으로 폴백
        // 앤츠톡/노드마스터 딥링크가 /chart/<chartId> 형식으로 들어옴 — 권한은 서버가 검사
        const direct = await fetch(`/request/gantt-chart/${shareToken}`, {
          credentials: 'include',
        });
        const directData = await direct.json().catch(() => null);
        if (direct.ok && directData?.success) {
          handleLoadChart(shareToken);
          return;
        }
        toast.error(data.message || '공유 링크가 유효하지 않습니다');
        navigate('/');
      } catch (error) {
        console.error('공유 링크 접속 오류:', error);
        toast.error('공유 링크 접속에 실패했습니다');
        navigate('/');
      }
    };

    loadSharedChart();
  }, [shareToken, isLoggedIn]);

  // 태스크 선택 변경 시 소켓으로 전송
  useEffect(() => {
    collab.selectTask(selectedTask || null);
  }, [selectedTask, collab]);

  // 컴포넌트 언마운트 시 소켓 Room 나가기
  useEffect(() => {
    return () => {
      leaveChart();
    };
  }, [leaveChart]);

  // ===== 파일 관리 함수들 =====
const reorderTasks = (reorderedTasks) => {
  collab.reorderTasks(reorderedTasks);
};
  // 저장 버튼 클릭 핸들러 (새로운 로직)
// 기존 파일 저장용 함수 (새로 생성)
const handleSaveExistingFile = async () => {
  if (!currentFileName) {
    setIsSaveModalOpen(true);
    return;
  }
  
  setIsLoading(true);
  
  try {
    const serializedTasks = tasks.map(task => ({
      ...task,
      startDate: task.startDate.toISOString(),
      endDate: task.endDate.toISOString()
    }));
    
    const serializedMilestones = milestones.map(milestone => ({
      ...milestone,
      date: milestone.date.toISOString()
    }));
    
    const response = await fetch('/request/save-gantt', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        title: currentFileName, // currentFileName 직접 사용
        tasks: serializedTasks,
        milestones: serializedMilestones,
        users: users,
        taskTypes: taskTypes,
        chart_type: currentChartType,
      })
    });
    
    const data = await response.json();
    
    if (data.success) {
      setCurrentFileId(data.chartId || data.id);
      toast.success(`"${currentFileName}" 간트차트가 저장되었습니다.`);
    } else {
      toast.error(data.message || '저장에 실패했습니다.');
    }
  } catch (error) {
    console.error('저장 오류:', error);
    toast.error('서버 연결 중 오류가 발생했습니다.');
  } finally {
    setIsLoading(false);
  }
};

// handleSave 함수 수정
const handleSave = async () => {
  if (currentFileId && currentFileName) {
    // 기존 파일이 있으면 바로 저장
    await handleSaveExistingFile();
  } else {
    // 새 파일이면 저장 모달 열기
    setIsSaveModalOpen(true);
  }
};

  // 새 파일로 저장 (기존 handleSaveChart 수정)
  const handleSaveChart = async () => {
    if (!chartTitle.trim()) {
      toast.error('차트 제목을 입력해주세요.');
      return;
    }
    
    setIsLoading(true);
    
    try {
      const serializedTasks = tasks.map(task => ({
        ...task,
        startDate: task.startDate.toISOString(),
        endDate: task.endDate.toISOString()
      }));
      
      const serializedMilestones = milestones.map(milestone => ({
        ...milestone,
        date: milestone.date.toISOString()
      }));
      
      const response = await fetch('/request/save-gantt', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          title: chartTitle,
          tasks: serializedTasks,
          milestones: serializedMilestones,
          users: users,
          taskTypes: taskTypes,
          chart_type: currentChartType,
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        // 저장 후 현재 파일 정보 설정
        const newChartId = data.chartId || data.id;
        const wasNew = !currentFileId; // 처음 저장이었는지 판단
        setCurrentFileName(chartTitle);
        setCurrentFileId(newChartId);
        // 팀 차트면 소켓 Room 참가 + 처음 저장이면 공유 모달 자동 오픈
        if (currentChartType === 'team' && newChartId) {
          joinChart(newChartId);
          if (wasNew) {
            // 살짝 시차를 두고 공유 모달 열어 사용자에게 초대 흐름을 안내
            setTimeout(() => setIsShareModalOpen(true), 200);
          }
        }
        toast.success('간트차트가 저장되었습니다.');
        setIsSaveModalOpen(false);
        //setChartTitle('');
      } else {
        toast.error(data.message || '저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('저장 오류:', error);
      toast.error('서버 연결 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  // 새 파일 시작
  const handleNewFile = async () => {
    if (tasks.length > 0 || milestones.length > 0 || users.length > 0) {
      const ok = await confirmDialog('현재 작업 중인 내용이 있습니다. 새 파일을 시작하시겠습니까?');
      if (!ok) return;
    }
    // 타입 선택 모달부터 띄움 (실제 초기화는 선택 후 handleChartTypePicked에서)
    setIsChartTypeModalOpen(true);
  };

  // 홈(환영 대시보드)으로 이동
  const handleGoHome = async () => {
    if (tasks.length > 0 || milestones.length > 0 || users.length > 0) {
      const ok = await confirmDialog('작업 중인 차트를 닫고 홈으로 가시겠습니까? 저장하지 않은 변경사항은 사라집니다.');
      if (!ok) return;
    }
    leaveChart();
    setCurrentFileName(null);
    setCurrentFileId(null);
    setTasks([]);
    setMilestones([]);
    setUsers([]);
    setSelectedTask(null);
    setSelectedMilestone(null);
    setCurrentChartType('personal');
    setWelcomeDismissed(false); // 환영 화면 다시 보이게
  };

  const handleChartTypePicked = (type) => {
    setIsChartTypeModalOpen(false);
    // 소켓 Room 나가기
    leaveChart();

    setCurrentFileName(null);
    setCurrentFileId(null);
    setTasks(buildTutorialTasks());
    setMilestones([]);
    setUsers([]);
    setSelectedTask(null);
    setSelectedMilestone(null);
    setWelcomeDismissed(true);
    setCurrentChartType(type);

    if (type === 'team') {
      // 팀 차트는 처음부터 차트명 받고 저장해야 협업 모드가 작동
      setChartTitle("");
      setIsSaveModalOpen(true);
      toast.success('팀 차트 이름을 정해주세요. 저장 후 바로 멤버 초대 가능합니다.');
    } else {
      toast.success('새 개인 차트를 시작합니다.');
    }
  };

  // 저장된 차트 목록 불러오기
  const fetchSavedCharts = async () => {
    try {
      setIsLoading(true);
      const response = await fetch('/request/gantt-charts', {
        credentials: 'include'
      });
      
      if (!response.ok) {
        throw new Error('차트 목록을 불러올 수 없습니다.');
      }
      
      const data = await response.json();
      
      if (data.success) {
        setSavedCharts(data.charts);
      } else {
        toast.error(data.message || '차트 목록을 불러올 수 없습니다.');
      }
    } catch (error) {
      console.error('차트 목록 조회 오류:', error);
      toast.error('서버 연결 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  // 차트 불러오기 기능 (수정)
  const handleLoadChart = async (chartId) => {
    setIsLoading(true);
    
    try {
      const response = await fetch(`/request/gantt-chart/${chartId}`, {
        credentials: 'include'
      });
      
      const data = await response.json();
      
      if (data.success) {
        const loadedTasks = data.chart.tasks.map(task => ({
          ...task,
          startDate: new Date(task.startDate),
          endDate: new Date(task.endDate)
        }));
        
        const loadedMilestones = data.chart.milestones.map(milestone => ({
          ...milestone,
          date: new Date(milestone.date)
        }));
        
        setTasks(loadedTasks);
        setMilestones(loadedMilestones);
        
        if (data.chart.users && data.chart.users.length > 0) {
          setUsers(data.chart.users);
        }

        // 현재 파일 정보 설정 (중요!)
        setCurrentFileName(data.chart.title);
        setCurrentFileId(chartId);
        const loadedType = data.chart.chart_type === 'team' ? 'team' : 'personal';
        setCurrentChartType(loadedType);

        // 소켓 Room 참가 - 팀 차트일 때만 실시간 협업 활성화
        if (loadedType === 'team') {
          joinChart(chartId);
        }

        setIsLoadModalOpen(false);
        toast.success('간트차트를 불러왔습니다.');
      } else {
        toast.error(data.message || '차트를 불러올 수 없습니다.');
      }
    } catch (error) {
      console.error('불러오기 오류:', error);
      toast.error('서버 연결 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  // 차트 이름 변경
  const handleRenameChart = async (chartId) => {
    const chart = savedCharts.find((c) => c.id === chartId);
    const currentTitle = chart?.title || "";
    const newTitle = await promptDialog("새 차트 이름을 입력하세요", currentTitle);
    if (!newTitle || newTitle.trim() === "" || newTitle === currentTitle) return;

    try {
      const res = await fetch(`/request/gantt-chart/${chartId}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ title: newTitle.trim() }),
      });
      const data = await res.json();
      if (!data.success) {
        toast.error(data.message || "이름 변경 실패");
        return;
      }
      toast.success("이름이 변경되었습니다");
      // 목록 및 현재 파일명 갱신
      setSavedCharts((prev) => prev.map((c) => (c.id === chartId ? { ...c, title: newTitle.trim() } : c)));
      if (currentFileId === chartId) setCurrentFileName(newTitle.trim());
    } catch (e) {
      console.error("이름 변경 오류:", e);
      toast.error("서버 연결 중 오류가 발생했습니다.");
    }
  };

  // 차트 삭제 기능
  const handleDeleteChart = async (chartId) => {
    if (!await confirmDialog('정말로 이 차트를 삭제하시겠습니까?')) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      const response = await fetch(`/request/gantt-chart/${chartId}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSavedCharts(savedCharts.filter(chart => chart.id !== chartId));
        
        // 현재 열린 파일이 삭제된 경우 초기화
        if (currentFileId === chartId) {
          setCurrentFileName(null);
          setCurrentFileId(null);
        }
        
        toast.success('간트차트가 삭제되었습니다.');
      } else {
        toast.error(data.message || '차트를 삭제할 수 없습니다.');
      }
    } catch (error) {
      console.error('삭제 오류:', error);
      toast.error('서버 연결 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  // ===== 기존 함수들 (협업 훅 연동) =====

  const addTask = (task) => {
    const taskWithColor = {
      ...task,
      color: task.color || getTaskColor(task.type || 'development'),
      baselineProgress: task.baselineProgress || 0,
      progress: task.progress || 0
    };
    collab.addTask(taskWithColor);
  };

  const updateTask = (updatedTask) => {
    collab.updateTask(updatedTask);
  };

  const deleteTask = (taskId) => {
    collab.deleteTask(taskId);
  };

  const addMilestone = (milestone) => {
    collab.addMilestone(milestone);
  };

  const updateMilestone = (updatedMilestone) => {
    collab.updateMilestone(updatedMilestone);
  };

  const deleteMilestone = (milestoneId) => {
    collab.deleteMilestone(milestoneId);
  };

  // 담당자 관리 함수들
  const handleAddMember = (newMember) => {
    try {
      // SSO 사용자(팀 차트) → user_id를 SSO UUID로 직접 사용. 그래야 푸시 알람·매핑 일관성 확보.
      // 수동 추가(개인 차트) → 기존처럼 'user1', 'user2' 형식
      const memberId = newMember.ssoUserId
        ? String(newMember.ssoUserId)
        : `user${users.length + 1}`;

      // 중복 방지 (같은 SSO 사용자 두 번 추가 막기)
      if (users.some((u) => String(u.id) === memberId)) {
        toast.error('이미 담당자로 추가된 사용자입니다.');
        return;
      }

      const member = {
        id: memberId,
        name: newMember.name,
        avatar: newMember.avatar,
      };
      collab.addMember(member);
      toast.success('담당자가 추가되었습니다.');
    } catch (error) {
      console.error('담당자 추가 오류:', error);
      toast.error('담당자 추가 중 오류가 발생했습니다.');
    }
  };

  const handleEditMember = (memberId, updatedMember) => {
    try {
      const memberIndex = users.findIndex(user => user.id === memberId);
      if (memberIndex === -1) {
        toast.error('담당자를 찾을 수 없습니다.');
        return;
      }

      collab.updateMember(memberId, {
        name: updatedMember.name,
        avatar: updatedMember.avatar
      });
      toast.success('담당자 정보가 수정되었습니다.');
    } catch (error) {
      console.error('담당자 수정 오류:', error);
      toast.error('담당자 수정 중 오류가 발생했습니다.');
    }
  };

  const handleRemoveMember = async (memberId) => {
    try {
      const assignedTasks = tasks.filter(task => task.assignee === memberId);

      if (assignedTasks.length > 0) {
        const ok = await confirmDialog(
          `이 담당자는 ${assignedTasks.length}개의 작업에 할당되어 있습니다. 삭제하면 이 작업들의 담당자가 없어집니다. 계속하시겠습니까?`
        );
        if (!ok) return;

        setTasks(tasks.map(task =>
          task.assignee === memberId ? { ...task, assignee: null } : task
        ));
      }

      collab.removeMember(memberId);
      toast.success('담당자가 제거되었습니다.');
    } catch (error) {
      console.error('담당자 제거 오류:', error);
      toast.error('담당자 제거 중 오류가 발생했습니다.');
    }
  };

  // JSON 내보내기/가져오기 함수들
  const handleExportJson = () => {
    try {
      const serializedTasks = tasks.map(task => ({
        ...task,
        startDate: task.startDate.toISOString(),
        endDate: task.endDate.toISOString()
      }));
      
      const serializedMilestones = milestones.map(milestone => ({
        ...milestone,
        date: milestone.date.toISOString()
      }));
      
      const chartData = {
        tasks: serializedTasks,
        milestones: serializedMilestones,
        users: users
      };
      
      const dataStr = JSON.stringify(chartData, null, 2);
      const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
      
      const exportFileDefaultName = `gantt-chart-${new Date().toISOString().slice(0, 10)}.json`;
      
      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
      
      toast.success('JSON 파일로 내보내기를 완료했습니다.');
    } catch (error) {
      console.error('JSON 내보내기 오류:', error);
      toast.error('JSON 내보내기 중 오류가 발생했습니다.');
    }
  };

  const handleFileImport = (event) => {
    const file = event.target.files[0];
    
    if (file) {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const importedData = JSON.parse(e.target.result);
          
          if (!importedData.tasks || !importedData.milestones) {
            toast.error('유효하지 않은 간트차트 파일입니다.');
            return;
          }
          
          const importedTasks = importedData.tasks.map(task => ({
            ...task,
            startDate: new Date(task.startDate),
            endDate: new Date(task.endDate)
          }));
          
          const importedMilestones = importedData.milestones.map(milestone => ({
            ...milestone,
            date: new Date(milestone.date)
          }));
          
          setTasks(importedTasks);
          setMilestones(importedMilestones);
          
          if (importedData.users && importedData.users.length > 0) {
            setUsers(importedData.users);
          }

          // 가져온 파일은 새 파일로 처리
          setCurrentFileName(null);
          setCurrentFileId(null);
          
          toast.success('JSON 파일을 성공적으로 불러왔습니다.');
        } catch (error) {
          console.error('JSON 가져오기 오류:', error);
          toast.error('JSON 파일을 가져오는 중 오류가 발생했습니다.');
        }
      };
      
      reader.readAsText(file);
    }
  };

  return (
    <AppLayout>
      <DrawerBackdrop $open={isDrawerOpen} onClick={() => setIsDrawerOpen(false)} />
      <DrawerSlot $open={isDrawerOpen}>
        <GlobalDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          charts={savedCharts}
          currentFileId={currentFileId}
          onNewChart={() => setIsChartTypeModalOpen(true)}
          onGoHome={handleGoHome}
          onSelectChart={handleLoadChart}
          onOpenLoadModal={() => { fetchSavedCharts(); setIsLoadModalOpen(true); }}
          onToggleSidebar={() => setIsMobileSidebarOpen((v) => !v)}
        />
      </DrawerSlot>
      <Container>
      <Header
        zoomLevel={zoomLevel}
        setZoomLevel={setZoomLevel}
        viewMode={viewMode}
        setViewMode={setViewMode}
        setIsSaveModalOpen={setIsSaveModalOpen}
        fetchSavedCharts={fetchSavedCharts}
        setIsLoadModalOpen={setIsLoadModalOpen}
        setIsMembersModalOpen={setIsMembersModalOpen}
        handleExportJson={handleExportJson}
        handleFileImport={handleFileImport}
        setIsColorModalOpen={setIsColorModalOpen}
        currentFileName={currentFileName}
        handleSave={handleSave}
        handleNewFile={handleNewFile}
        currentFileId={currentFileId}
        setIsShareModalOpen={setIsShareModalOpen}
        setIsAlarmModalOpen={setIsAlarmModalOpen}
        currentChartType={currentChartType}
        handleGoHome={handleGoHome}
        onToggleSidebar={() => setIsMobileSidebarOpen((v) => !v)}
        onOpenDrawer={() => { fetchSavedCharts(); setIsDrawerOpen(true); }}
        activeTab={activeTab}
        onAddTask={() => setAddTaskNonce((n) => n + 1)}
        onAddMilestone={() => setAddMilestoneNonce((n) => n + 1)}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        chartTheme={chartTheme}
        setChartTheme={setChartTheme}
        referenceDate={referenceDate}
        setReferenceDate={setReferenceDate}
        isDashboardEmpty={!currentFileId && tasks.length === 0 && milestones.length === 0 && !welcomeDismissed}
      />
      
        {!currentFileId && tasks.length === 0 && milestones.length === 0 && !welcomeDismissed ? (
          <WelcomeDashboard
            onNewChart={() => setIsChartTypeModalOpen(true)}
            onLoadChart={handleLoadChart}
            onOpenLoadModal={() => {
              fetchSavedCharts()
              setIsLoadModalOpen(true)
            }}
            onImportFile={handleFileImport}
          />
        ) : chartTheme === "wbs" ? (
          <ChartContainer>
            <GanttChartWBS
              tasks={tasks}
              users={users}
              projectName={currentFileName || "새 프로젝트"}
              zoomLevel={zoomLevel}
              setZoomLevel={setZoomLevel}
              referenceDate={referenceDate}
              setReferenceDate={setReferenceDate}
              chartId={currentFileId}
              currentUserId={user?.ssoUserId || user?.userId}
              onTaskSelect={(taskId) => {
                setSelectedTask(taskId)
                setSelectedMilestone(null)
                setActiveTab("tasks")
              }}
            />
          </ChartContainer>
        ) : chartTheme === "report" ? (
          <ChartContainer>
            <ReportView
              tasks={tasks}
              users={users}
              projectName={currentFileName || "새 프로젝트"}
              referenceDate={referenceDate}
            />
          </ChartContainer>
        ) : (
          <ResizableContainer>
            <MobileBackdrop $show={isMobileSidebarOpen} onClick={() => setIsMobileSidebarOpen(false)} />
            <SidebarContainer width={sidebarWidth} $open={isMobileSidebarOpen} data-cursor-anchor="sidebar">
              <Sidebar
                tasks={tasks}
                users={users}
                milestones={milestones}
                selectedTask={selectedTask}
                setSelectedTask={setSelectedTask}
                setSelectedMilestone={setSelectedMilestone}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                selectedMilestone={selectedMilestone}
                addTask={addTask}
                updateTask={updateTask}
                deleteTask={deleteTask}
                addMilestone={addMilestone}
                updateMilestone={updateMilestone}
                deleteMilestone={deleteMilestone}
                taskTypes={taskTypes}
                reorderTasks={reorderTasks}
                referenceDate={referenceDate}
                setReferenceDate={setReferenceDate}
                openBacklog={currentFileId ? () => setIsBacklogOpen(true) : null}
                openTaskNote={currentFileId ? (task) => setNoteTask(task) : null}
                addTaskNonce={addTaskNonce}
                addMilestoneNonce={addMilestoneNonce}
                onExport={handleExportJson}
                onOpenLoadModal={() => { fetchSavedCharts(); setIsLoadModalOpen(true); }}
                searchQuery={searchQuery}
              />
            </SidebarContainer>
            <ResizeHandle
              onMouseDown={handleMouseDown}
              style={{
                backgroundColor: isResizing ? '#9ca3af' : '#e5e7eb'
              }}
            />
            <ChartContainer>
              <StatsStrip tasks={tasks} referenceDate={referenceDate} setReferenceDate={setReferenceDate} />
              <ChartBody>
                <GanttChart
                  tasks={tasks}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  users={users}
                  milestones={milestones}
                  selectedTask={selectedTask}
                  setSelectedTask={setSelectedTask}
                  updateTask={updateTask}
                  zoomLevel={zoomLevel}
                  setZoomLevel={setZoomLevel}
                  viewMode={viewMode}
                  setSelectedMilestone={setSelectedMilestone}
                  selectedMilestone={selectedMilestone}
                  referenceDate={referenceDate}
                  setReferenceDate={setReferenceDate}
                />
              </ChartBody>
            </ChartContainer>
            <DetailsSlot $open={!!selectedTask}>
              {selectedTask && (
                <TaskDetailsPanel
                  task={tasks.find((t) => t.id === selectedTask)}
                  tasks={tasks}
                  users={users}
                  taskTypes={taskTypes}
                  referenceDate={referenceDate}
                  onUpdate={(updated) => updateTask(updated)}
                  onDelete={() => { deleteTask(selectedTask); setSelectedTask(null); }}
                  onClose={() => setSelectedTask(null)}
                />
              )}
            </DetailsSlot>
          </ResizableContainer>
        )}
      
      {/* 저장 모달 */}
      {isSaveModalOpen && (
        <SaveChartModal
          isOpen={isSaveModalOpen}
          onClose={() => setIsSaveModalOpen(false)}
          title={chartTitle}
          setTitle={setChartTitle}
          onSave={handleSaveChart}
          isLoading={isLoading}
        />
      )}
      
      {/* 불러오기 모달 */}
      {isLoadModalOpen && (
        <LoadChartModal
          isOpen={isLoadModalOpen}
          onClose={() => setIsLoadModalOpen(false)}
          charts={savedCharts}
          onLoad={handleLoadChart}
          onDelete={handleDeleteChart}
          onEdit={handleRenameChart}
          isLoading={isLoading}
        />
      )}
      
      {/* 담당자 관리 모달 */}
      {isMembersModalOpen && (
        <MembersModal
          isOpen={isMembersModalOpen}
          onClose={() => setIsMembersModalOpen(false)}
          members={users}
          onAddMember={handleAddMember}
          onRemoveMember={handleRemoveMember}
          onEditMember={handleEditMember}
          chartType={currentChartType}
          chartId={currentFileId}
        />
      )}
      
      {/* 색상 설정 모달 */}
      {isColorModalOpen && (
        <ColorSettingsModal
          isOpen={isColorModalOpen}
          onClose={() => setIsColorModalOpen(false)}
          taskTypes={taskTypes}
          onSave={handleSaveTaskColors}
        />
      )}

      {/* 공유 모달 */}
      {isShareModalOpen && currentFileId && (
        <ShareModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          chartId={currentFileId}
        />
      )}

      {/* 새 차트 타입 선택 모달 */}
      {isChartTypeModalOpen && (
        <ChartTypeSelectModal
          isOpen={isChartTypeModalOpen}
          onClose={() => setIsChartTypeModalOpen(false)}
          onSelect={handleChartTypePicked}
        />
      )}

      {/* 작업 노트 패널 (우측 슬라이드) */}
      {noteTask && (
        <TaskNotePanel
          isOpen={!!noteTask}
          onClose={() => setNoteTask(null)}
          chartId={currentFileId}
          task={noteTask}
        />
      )}

      {/* 알람 설정 모달 */}
      {isAlarmModalOpen && (
        <AlarmSettingsModal
          isOpen={isAlarmModalOpen}
          onClose={() => setIsAlarmModalOpen(false)}
        />
      )}

      {/* 전역 원격 커서 레이어 (타임라인 밖 영역 — 영역 앵커/화면 비율로 자동 보정) */}
      <GlobalCursorLayer currentView={chartTheme === "wbs" ? "wbs" : "classic"} />

      {/* 좌측 글로벌 드로어는 AppLayout 안 DrawerSlot 으로 이동(컨텐츠 밀어내기) */}

      {/* 백로그(작업 목록) 모달 */}
      {isBacklogOpen && (
        <BacklogModal
          isOpen={isBacklogOpen}
          onClose={() => setIsBacklogOpen(false)}
          chartId={currentFileId}
          onPickToTask={(item) => {
            // 백로그 항목을 오늘부터 7일짜리 작업으로 추가
            const start = new Date();
            start.setHours(0, 0, 0, 0);
            const end = new Date(start);
            end.setDate(end.getDate() + 7);
            addTask({
              id: Date.now().toString(),
              name: item.title,
              startDate: start,
              endDate: end,
              progress: 0,
              dependencies: [],
              description: item.description || "",
              type: "development",
            });
            toast.success(`"${item.title}" 작업으로 추가됨 (오늘 ~ +7일)`);
          }}
        />
      )}
      </Container>
    </AppLayout>
  );
}
